import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EndpointService} from './endpoint.service';
import {PostOrderRequest} from '../requests/PostOrderRequest';
import {ReturnPaymentInfoResponse} from '../responses/ReturnPaymentInfoResponse';
import {GetTaxInfoResponse} from '../responses/GetTaxInfoResponse';
import {PostOrderResponse} from '../responses/PostOrderResponse';
import {PaymentRetryResponse} from '../responses/PaymentRetryResponse';
import {RetryPaymentRequest} from '../requests/RetryPaymentRequest';


@Injectable({providedIn: 'root'})
export class PaymentService {
  constructor(private _http: HttpClient) {
  }

  // used for not enough money or normal payment from balance (we will receive Netopia info)
  postSimpleOrder(data: PostOrderRequest) {
    return this._http.post<PostOrderResponse>(EndpointService.postSimpleOrder, data);
  }

  postDirectOrder(data: PostOrderRequest) {
    return this._http.post<PostOrderResponse>(EndpointService.postDirectOrder, data);
  }

  returnPaymentInfo(orderId: string) {
    return this._http.get<ReturnPaymentInfoResponse>(EndpointService.returnPaymentInfo + `?orderId=${orderId}`);
  }

  getTaxForBenefit(
    benefitId: number,
    quantity: number,
    beneficiary: boolean,
    meta: string,
    cardPaymentOnly: boolean = false,
    salaryPaymentOnly: boolean = false
  ) {
    return this._http.get<GetTaxInfoResponse>(
      EndpointService.getTaxForBenefit +
      `?benefitId=${benefitId}` +
      `&quantity=${quantity}` +
      `&beneficiary=${beneficiary}` +
      `&meta=${meta}` +
      `&cardPaymentOnly=${cardPaymentOnly}` +
      `&salaryPaymentOnly=${salaryPaymentOnly}`);
  }

  retrySimpleOrder(data: RetryPaymentRequest) {
    return this._http.post<PaymentRetryResponse>(EndpointService.retrySimpleOrder, data);
  }

  retryDirectOrder(data: RetryPaymentRequest) {
    return this._http.post<PaymentRetryResponse>(EndpointService.retryDirectOrder, data);
  }

  retrySimpleSubscription(data: RetryPaymentRequest) {
    return this._http.post<PaymentRetryResponse>(EndpointService.retrySimpleSubscription, data);
  }

  retryDirectSubscription(data: RetryPaymentRequest) {
    return this._http.post<PaymentRetryResponse>(EndpointService.retryDirectSubscription, data);
  }
}
